const VUL = {
  locale: "fr",
  messages: {
    flowScene: {
      filters: {
        flowTypes: {
          delivery: "Camionnettes",
        },
      },
      flowType: {
        delivery: "{count, plural, one {camionnette} other {camionnettes}}",
        short_delivery: "Cam.",
      },
    },
    indicatorsScene: {
      table: {
        header: {
          delivery_vans: "Camionnettes",
        },
      },
    },
  },
};

export default VUL;
